import React from 'react';

function LogoutButton(props) {
  const style = {
    cursor: 'pointer',
  };

  return <span className="ic-close" title="Logout" onClick={props.logout} style={style}></span>;
}

export default LogoutButton;
